interface Props {
  isFetching: boolean;
  totalAmount: number;
  discountedTotalAmount?: number;
}
const StickyCartBarContent = ({
  isFetching,
  totalAmount,
  discountedTotalAmount,
}: Props) => {
  return discountedTotalAmount ? (
    <>
      <div className="flex items-end gap-4 text-gray-000">
        <span className="shrink-0 typo-paragraph100-regular disable-text-size-adjust">
          나의할인가
        </span>
        <span className="truncate typo-heading100">
          {!isFetching ? (
            '계산중...'
          ) : (
            <>{discountedTotalAmount.toLocaleString()}원</>
          )}
        </span>
      </div>
      <div className="flex items-center gap-4 text-gray-000 opacity-70 typo-caption100-regular disable-text-size-adjust">
        <span className="shrink-0">총 금액</span>
        <span className="truncate">
          {!isFetching ? '계산중...' : <>{totalAmount.toLocaleString()}원</>}
        </span>
      </div>
    </>
  ) : (
    <div className="flex items-end gap-6 text-gray-000">
      <span className="shrink-0 typo-paragraph100-regular disable-text-size-adjust">
        총 금액
      </span>
      <span className="truncate typo-heading100">
        {!isFetching ? '계산중...' : <>{totalAmount.toLocaleString()}원</>}
      </span>
    </div>
  );
};

export default StickyCartBarContent;
